import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_TMt4InDJq7R2: {
	id: 'prd_TMt4I2DEV2nDJq7R2'
	ident: 'prd_TMt4InDJq7R2'
	sku: 'simple_premium_4w_7_99_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_GqFmO2DEV2qLIuJaa'
			amount: 44
			amount_usd: 7.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 7.99
			discount: 36.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_cBDsy2DEV2zgLHZYW'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_TMt4InDJq7R2, SubscriptionProduct>
const prd_TMt4InDJq7R2 = { ident: 'prd_TMt4InDJq7R2' } as typeof _prd_TMt4InDJq7R2

export default prd_TMt4InDJq7R2
